import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';
import { useApi } from '../api/contexts/ApiContext';
import Header from '../components/Header'; // Import Header component
import { useSelector } from 'react-redux'; // Import useSelector for accessing Redux state
import { RootState } from '../store'; // Import RootState type
import ProjectTitle from '../components/ProjectTitle';
import { getFacilityByOpportunityIdInterface } from '../api/interfaces/IFacilityApi'; // Import the interface
import { Spinner } from 'react-bootstrap';

const ContactList = () => {
    const location = useLocation();
    const navigate = useNavigate();
    // const { opportunityId } = location.state || {};
    const queryParams = new URLSearchParams(location.search);
    const opportunityId: number = parseInt(queryParams.get('opportunity_id') || '0', 10);
    console.log(opportunityId);
    // const { facility_id } = location.state || {};
    const facility_id: number = parseInt(queryParams.get('facility_id') || '0', 10);
    const [facilityId, setFacilityId] = useState(facility_id || '');
    const [facilityName, setFacilityName] = useState('すべて');
    const [questions, setQuestions] = useState<any>([]);
    const [facilities, setFacilities] = useState<any[]>([]); // Specify the type as an array
    const [opportunity, setOpportunity] = useState<any>();
    const { userInfo } = useSelector((state: RootState) => state.auth); // Access userInfo from Redux state
    const { vendorInfo } = useSelector((state: RootState) => state.vendor);
    const { getModule } = useApi();
    const [loading, setLoading] = useState(false); // Add loading state

    useEffect(() => {
        if (!opportunityId) {
            navigate('/');
            return;
        }

        const fetchData = async () => {
            setLoading(true); // Set loading to true when fetch starts
            try {
                const OpportunityApi = await getModule('OpportunityApi'); // Corrected module name
                const Opportunity = await OpportunityApi.getOpportunity({ opportunity_id: opportunityId }); // Corrected method call
                console.log(Opportunity);
                if (!Opportunity) {
                    navigate('/notfound');
                    return;
                }
                setOpportunity(Opportunity.data);
                const FacilityApi = await getModule('FacilityApi');
                const facilityData = await FacilityApi.getFacilityByOpportunityId({ opportunity_id: opportunityId }) as { data: { id: number; name: string; }[] }; // Type assertion
                setFacilities(facilityData.data);
                console.log(facilityData);

                const GeneralApi = await getModule('GeneralApi');

                if (!userInfo) return null; // or a loading state

                const questionData = await GeneralApi.getQuestion({ opportunity_id: opportunityId, user_id: userInfo!.id }); // Corrected method call with non-null assertion
                console.log(questionData.data);
                setQuestions(questionData.data);
                console.log(facilityId);

                if (facilityId) {
                    const selectedFacility = facilityData.data.find((f) => f.id == facilityId);
                    console.log(selectedFacility);
                    if (selectedFacility) {
                        console.log(selectedFacility.name);
                        setFacilityName(selectedFacility.name);
                    }
                } else {
                    setFacilityName('すべて');
                }
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false); // Set loading to false when fetch ends
            }
        };

        fetchData();
    }, [opportunityId, facilityId, navigate]);

    const handleFacilityChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedFacilityId = e.target.value;
        if (selectedFacilityId === '0') {
            setFacilityId('');
            navigate(`/contact_list?opportunity_id=${opportunityId}`);
        } else {
            setFacilityId(selectedFacilityId);
            navigate(`/contact_list?opportunity_id=${opportunityId}&facility_id=${selectedFacilityId}`);
        }
    };

    const filteredQuestions = facilityId
        ? questions.filter((q: any) =>
            q.question_supply_points.some((sp: any) => sp.supply_point_id == facilityId)
        )
        : questions;

    return (
        <div>

            <section className="section-name project-details-section">
                <div className="container">
                    {opportunity && <ProjectTitle company={opportunity} />}

                    <div className="bg_box-inquiry mb-5 pt-3 p-5">
                        <div className="row">
                            <div className="col-lg-5 col-md-7 col-10 mx-auto py-3 mb-3">
                                <div className="bg-white text-center rounded-pill text-sm py-1 fw-300">
                                    <img className="img img-fluid height-25 mb-1 mr-2" src="assets/images/title-book.svg" alt="icon" />
                                    この企業・施設への問い合わせ
                                </div>
                            </div>
                        </div>
                        <div className="row form-theme m-0 mb-3">
                            <div className="col-4 d-flex align-items-baseline">
                                <span className="label col-lg-4 pl-0">表示する施設</span>
                                <div className="input-group col-lg-8">
                                    <select
                                        className="custom-select theme-form-select rounded-0"
                                        value={facilityId}
                                        onChange={handleFacilityChange}
                                    >
                                        <option value="0">全て</option>
                                        {facilities.map((facility: any) => (
                                            <option key={facility.id} value={facility.id}>
                                                {facility.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                        {loading ? ( // Show loading UI when loading is true
                            <div className="text-center">
                                <Spinner animation="border" variant="primary" />
                            </div>
                        ) : (
                            filteredQuestions.map((q: any) => (
                                <div key={q.id}>
                                    <div className="theme-box-gray pl-3 pr-3 pt-2 pb-2 border-bottom-1">
                                        <div className="table-demo-header p-3">
                                            <div className="row mx-0 fw-300">
                                                <div className="col-sm-6 px-0 my-auto">
                                                    <div className="mb-sm-0 mb-3 d-flex align-items-baseline">
                                                        <img
                                                            className="img img-fluid height-10 d-inline-block mb-sm-0 mb-2 mr-2 action-class"
                                                            src="assets/images/other/icon-up-arrow.svg"
                                                            alt="icon"
                                                        />
                                                        <p className="mb-0">{q.title || ''}</p>
                                                    </div>
                                                </div>
                                                <div className="col-sm-5 px-0 my-auto">{facilityName}</div>
                                                <div className="col-sm-1 px-0 my-auto text-right">
                                                    {q.created_at ? new Date(q.created_at).toLocaleDateString() : ''}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="action-class-wrapper open">
                                            <div className="bg-white">
                                                <div className="border-bottom-1 p-4">
                                                    <div className="padding-td-5 td-min-w-60">
                                                        {(q.question || '').split('\n').map((line: string, index: number) => (
                                                            <p key={index} className="mb-1" style={{ margin: 0 }}>{line}</p>
                                                        ))}
                                                    </div>
                                                </div>
                                                <div className="p-4">
                                                    <div className="padding-td-5 td-min-w-60">
                                                        {(q.answer || '').split('\n').map((line: string, index: number) => (
                                                            <p key={index} style={{ margin: 0 }}>{line}</p>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                    <div className="py-3 mb-3 text-center">
                        <a href={`/project_detail?opportunity_id=${opportunityId}`}>
                            <button type="button" className="btn btn-theme btn-danger rounded-pill px-5 mr-2">
                                <span className="mx-3">案件に戻る</span>
                            </button>
                        </a>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
};

export default ContactList;